/* eslint-disable no-unused-vars */
import Vue from 'vue';

import axios from 'axios';
import * as _ from 'lodash';
import {
 get, post, patch, del,
} from '../../request';

function setCache(key, val) {
  if (!val) return localStorage.removeItem(`wowzi:${key}`);
  return localStorage.setItem(`wowzi:${key}`, JSON.stringify(val));
}

function getCache(key) {
  return JSON.parse(localStorage.getItem(`wowzi:${key}`));
}

async function uploadImages(imgArr, ref, id, url) {
  const promises = [];
  imgArr.forEach((img) => {
    const formData = new FormData();
    formData.append(ref, id);
    formData.append('file', img);
    promises.push(
      axios.post(url, formData, {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }),
    );
  });
  await Promise.all(promises);
}

const state = {
  profile: null,
  brands: [],
  agencyBrands: [],
  companyIndustries: [],
  companyTypes: [],
  merchantRoles: null,
  error: null,
  inviteError: null,
};

const getters = {
  merchants(s) {
    const m = [];
    s.agencyBrands.forEach((brand) => {
      brand.merchants.forEach((merchant) => {
        m.push({
          brandId: brand.id,
          brandName: brand.name,
          merchantId: merchant.id,
          name: merchant.name,
          email: merchant.email,
          merchantRole: merchant.merchant_role,
        });
      });
    });
    return m;
  },
  agency(s) {
    if (s.profile) {
      const agency = s.profile.companies.find(e => e.company_role === 'AGENCY');
      // .filter(e => e.merchant_role === 'MANAGER' || e.merchant_role === 'OWNER');
      if (agency) {
        return {
          ...s.agencyBrands.find(e => e.id === agency.id),
          merchantRole: agency.merchant_role,
        };
      }
      return null;
    }
    return null;
  },
  isAgencyOwner(s) {
    return (
      s.profile.companies
        .filter(e => e.company_role === 'AGENCY')
        .filter(e => e.merchant_role === 'OWNER').length > 0
    );
  },
};

const mutations = {
  error(s, e) {
    Vue.set(s, 'error', e);
  },
  setInviteError(s, e) {
    Vue.set(s, 'inviteError', e);
  },
  setProfile(s, data) {
    Vue.set(s, 'profile', data);
  },
  setBrands(s, data) {
    Vue.set(s, 'brands', data);
  },
  setAgencyBrands(s, data) {
    Vue.set(s, 'agencyBrands', data);
  },
  setCompanyTypes(s, data) {
    Vue.set(s, 'companyTypes', data);
  },
  setCompanyIndustries(s, data) {
    Vue.set(s, 'companyIndustries', data);
  },
  setMerchantRoles(s, data) {
    Vue.set(s, 'merchantRoles', data);
  },
};

const actions = {
  // Get Profile
  async doGetProfile({ commit }, recursive = true) {
    console.log('Fetching Profile Data');
    commit('error', null);
    try {
      const profile = await get('/user/merchant', { commit });
      commit('setProfile', profile);

      const companies = await get('/companies', { commit });
      commit(
        'setBrands',
        companies.sort((a, b) => (a.name < b.name ? -1 : 1)),
      );

      // If user has Agency
      if (profile.companies.find(e => e.company_role === 'AGENCY') && recursive) {
        const brands = [];
        profile.companies.forEach(async ({ id }) => {
            const data = await get(`/companies/${id}`, { commit });
            brands.push(data);
          commit('setAgencyBrands', [...brands.sort((a, b) => (a.name < b.name ? -1 : 1))]);
        });
      }
    } catch (e) {
      commit('error', e);
    }
  },
  // Post a new Brand
  async doCreateBrand({ commit }, form) {
    commit('error', null);
    try {
      const company = await post('/companies', form, { commit });
      const { files } = form;
      if (files && files.length > 0) {
        const { id } = company;
        await uploadImages(files, 'company_id', id, '/companies/logo/upload');
      }

      commit('doGetProfile', { commit });
    } catch (e) {
      commit('error', e);
    }
  },
  // Invite Merchant to brand
  async doInviteMerchantToBrand({ commit }, data) {
    commit('setInviteError', null);
    try {
      await post('/auth/invite/merchant', data, { commit });
    } catch (e) {
      commit('setInviteError', e);
    }
  },
  // Edit merchant permissions
  async doUpdateMerchantPermission({ commit }, { merchantId, data }) {
    commit('error', null);
    try {
      await patch(`/user/merchant/${merchantId}/role`, data, { commit });
      // commit('doGetProfile', { commit });
    } catch (e) {
      commit('error', e);
    }
  },
  // Edit merchant permissions
  async doRemoveMerchantFromCompany({ commit }, { merchantId, companyId }) {
    commit('error', null);
    try {
      await patch(`/user/merchants/${merchantId}/companies/${companyId}`, { commit });
      commit('doGetProfile', { commit });
    } catch (e) {
      commit('error', e);
    }
  },
  async doUploadBrandLogo({ commit }, blob) {
    //
  },
  async doInitialize({ commit }) {
    const companyTypes = await get('/conf/company_types', { commit });
    commit('setCompanyTypes', companyTypes);
    const companyIndustries = await get('/conf/company_industries', { commit });
    commit('setCompanyIndustries', companyIndustries);
    const merchantRoles = await get('/conf/merchant_roles', { commit });
    commit('setMerchantRoles', merchantRoles);
  },
};

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};
